/* ------------------------------------------------------------------
   GYMOTEC – eigene Fixes (wird von Theme-Updates NICHT ueberschrieben)

   1) "Aehnliche Produkte" / "Kunden kauften auch":
      Diese Section laedt ihre Karten per AJAX nach. Die nachgeladene
      HTML bringt ihr eigenes <script src="quick-add.js"> mit - per
      innerHTML eingefuegte Skripte werden vom Browser aber NIE
      ausgefuehrt. Dadurch ist <quick-add-modal> nie definiert,
      modal.show() existiert nicht und der Button tut gar nichts.
      Fix: quick-add.js einmal sauber nachladen, sobald global.js
      (ModalDialog) verfuegbar ist.

   2) Bulk-Quick-Add ("Sales der Woche"):
      Dawn laedt den Fensterinhalt nur per IntersectionObserver im
      Hintergrund. Klickt der Kunde vorher, bleibt das Fenster leer.
      Fix: Inhalt beim Klick nachladen, mit Spinner.
------------------------------------------------------------------ */
(function () {
  /* ---------- 1) quick-add.js nachladen ---------- */

  function loadQuickAdd() {
    if (window.customElements && window.customElements.get('quick-add-modal')) return;
    if (document.querySelector('script[data-gy-quick-add]')) return;

    var src = window.gymotecAssets && window.gymotecAssets.quickAdd;
    if (!src) return;

    // ModalDialog kommt aus global.js - ohne sie wirft quick-add.js
    if (typeof window.ModalDialog === 'undefined' && !window.customElements.get('modal-dialog')) {
      return window.setTimeout(loadQuickAdd, 150);
    }

    var script = document.createElement('script');
    script.src = src;
    script.setAttribute('data-gy-quick-add', '1');
    document.head.appendChild(script);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadQuickAdd);
  } else {
    loadQuickAdd();
  }
  window.addEventListener('load', loadQuickAdd);

  // Die Empfehlungen kommen spaeter per AJAX - dann erneut pruefen.
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          if (document.querySelector('[data-modal^="#QuickAdd-"]')) {
            loadQuickAdd();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- 2) Bulk-Quick-Add beim Klick befuellen ---------- */

  var SECTION = 'bulk-quick-order-list';

  function fill(bulkModal, button) {
    if (!bulkModal || bulkModal.innerHTML.trim() !== '') return;
    if (bulkModal.dataset.gyLoading === '1') return;
    bulkModal.dataset.gyLoading = '1';

    var spinner = button && button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    if (button) button.classList.add('loading');

    var base = (bulkModal.dataset.url || '').split('?')[0];
    if (!base) {
      bulkModal.dataset.gyLoading = '';
      return;
    }

    fetch(base + '?section_id=' + SECTION)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var container = doc.querySelector('.quick-order-list-container');
        if (container && container.parentNode) {
          bulkModal.innerHTML = container.parentNode.innerHTML;
        }
      })
      .catch(function (error) {
        console.error('[gymotec quick-add]', error);
      })
      .then(function () {
        bulkModal.dataset.gyLoading = '';
        if (spinner) spinner.classList.add('hidden');
        if (button) {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        }
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest('.quick-add__submit');
      if (!button) return;

      var opener = button.closest('modal-opener');
      if (!opener) return;

      var selector = opener.getAttribute('data-modal');
      if (!selector) return;

      // Standard-Quick-Add: sicherstellen, dass das Element definiert ist
      if (selector.indexOf('QuickAddBulk') === -1) {
        loadQuickAdd();
        return;
      }

      var modal = document.querySelector(selector);
      if (!modal) return;

      fill(modal.querySelector('bulk-modal'), button);
    },
    true
  );
})();